import {Icon, Page, Tile} from '../../shared';
import React from 'react';
import history from '../../history';
import {getBackPath} from '../shared/utils/dashboardUtils';
import WealthAlerts from '../widgets/containers/WealthAlerts';

const WealthAlertsPage = () => {
  const backPath = getBackPath();

  return <Page>
    <Tile key={'WealthAlerts'}
          title={'WealthAlerts'}
          minHeight={'250px'}
          height={'calc(100vh - 200px)'}
          icon={<Icon svg={'arrowCircle'}
                      rotate={'180deg'}
                      action={() => history.push(backPath)}/>}>
      <WealthAlerts/>
    </Tile>
  </Page>;
};

export default WealthAlertsPage;

